import { Directive, ViewContainerRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTodoContainer]',
  standalone: true,
})
export class TodoContainerDirective {
  date = input.required<Date>();

  // DI
  public vcr = inject(ViewContainerRef);
}
